import { render, staticRenderFns } from "./AgreementAdmin.vue?vue&type=template&id=e162b376&scoped=true"
import script from "./AgreementAdmin.vue?vue&type=script&lang=ts"
export * from "./AgreementAdmin.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e162b376",
  null
  
)

export default component.exports